var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-loading",style:({background:_vm.background})},[_c('van-loading',{attrs:{"color":"white"}}),_c('div',{staticClass:"ui-loading-title"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }